export default function getOrganizationFailedTnx(
  state = { error: null, success: null, processing: false },
  action
) {
  switch (action.type) {
    case "GET_ORGANIZATION_FAILED_SITE_SUCCESS":
      return { ...state, ...{ success: action.success } };

    case "GET_ORGANIZATION_FAILED_SITE_ERROR":
      return { ...state, ...{ error: action.error } };

    case "GET_ORGANIZATION_FAILED_SITE_PROCESSING":
      return { ...state, ...{ processing: action.processing } };

    default:
      return state;
  }
}
